// extracted by mini-css-extract-plugin
module.exports = {"title-bar-limits":"title-bar-limits__title-bar-limits___8bmJq","title-bar-warning":"title-bar-limits__title-bar-warning___2nLNa"};